import React from "react";
import { FormGroup, InputText, Button } from "@accessdev/arc-ui-react";
import { Creators } from "@ReduxStore/actionTypes";
import { connect } from "react-redux";
import { selectors } from "@ReduxStore/reducers";
import { Member } from "../../../constants";
import { usePreviousProps } from "@Src/hooks";
import { getAuthError, errorLocations } from "../authHelpers";
import LoadingSpinner from "@Src/components/LoadingSpinner";
import "./SignIn.scss";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
const { AUTHENTICATING, SIGN_IN_SUCCESSFUL } = Member;

function SignIn(props) {
  const { _ } = useLingui();
  const inputRef = React.useRef(null);
  const [values, setValues] = React.useState({
    email: "",
    password: "",
  });

  const [error, setError] = React.useState(null);

  const [loading, setLoading] = React.useState(false);

  const prevProps = usePreviousProps(props);

  React.useEffect(() => {
    if (props && prevProps) {
      watchLoginError();
      watchLoginSuccess();
    }
  });

  const handleInputChange = (event) => {
    if (error) setError(null);
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const onLoginSubmit = () => {
    setLoading(true);
    props.signIn({
      email: values.email.trim(),
      password: values.password.trim(),
    });
  };

  const watchLoginError = () => {
    if (props.authenticationError && prevProps.authenticationError !== props.authenticationError) {
      setLoading(false);
      setError(getAuthError(props.authenticationError.data.error_code, props.helpNumber));
    }
  };

  const watchLoginSuccess = () => {
    if (
      prevProps.authenticationStatus === AUTHENTICATING &&
      props.authenticationStatus === SIGN_IN_SUCCESSFUL
    ) {
      props.handleAuthSuccess();
      setLoading(false);
    }
  };

  const showInputError = (input) => {
    if (error) {
      if (error.location === input) {
        return _(error.errorMsg);
      }
    } else {
      if (input === errorLocations.SIGN_IN_EMAIL) return t`Please enter a valid email`;
      return t`Password is required`;
    }
  };

  const showGeneralError = () => {
    if (error && error.location === errorLocations.GENERAL) {
      return (
        <span
          className="SignIn-generalError t-body-med"
          dangerouslySetInnerHTML={{ __html: _(error.errorMsg) }}
        />
      );
    }
  };

  return (
    <div className="SignIn">
      <FormGroup onSubmit={() => onLoginSubmit()}>
        <section className="SignIn-form">
          <InputText
            {...{
              ref: inputRef,
              variant: "SignIn-input",
              errorMsg: showInputError("SignIn-email"),
              id: "email",
              isRequired: true,
              label: t`Email Address`,
              name: "email",
              onChange: handleInputChange,
              type: "text",
              validate: "email",
              value: values.email,
              requiredLabel: "",
              ...(error && error.location !== errorLocations.SIGN_IN_PASSWORD
                ? { isError: true }
                : null),
            }}
          />
          <div className="SignIn-passwordContainer">
            <InputText
              {...{
                variant: "SignIn-input",
                errorMsg: showInputError(errorLocations.SIGN_IN_PASSWORD),
                id: "password",
                isRequired: true,
                label: t`Password`,
                name: "password",
                onChange: handleInputChange,
                type: "password",
                value: values.password,
                requiredLabel: "",
                ...(error && error.location !== errorLocations.SIGN_IN_EMAIL
                  ? { isError: true }
                  : null),
              }}
            />
          </div>
          <div className="SignIn-btnContainer">
            {loading && <LoadingSpinner height="30px" width="30px" bottom="5%" />}
            <Button type="submit" isDisabled={loading} className="SignIn-submitBtn">
              <Trans>Sign In</Trans>
            </Button>
          </div>
          {showGeneralError()}
        </section>
      </FormGroup>
      <div className="SignIn-fpContainer">
        <a
          className="SignIn-resetPW ph:t-body-med tb:t-body-small"
          href={`${process.env.REACT_APP_RESETPW_API_URL}/${props.programKey}`}
        >
          <Trans>Forgot Password?</Trans>
        </a>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const {
    getProgramKey,
    getAuthenticationStatus,
    getAuthenticationStatusText,
    getAuthenticationError,
    getHelpPhoneNumber,
  } = selectors;
  return {
    authenticationStatus: getAuthenticationStatus(state),
    authenticationError: getAuthenticationError(state),
    errorText: getAuthenticationStatusText(state),
    programKey: getProgramKey(state),
    helpNumber: getHelpPhoneNumber(state),
  };
};

const { signIn } = Creators;

export default connect(mapStateToProps, {
  signIn,
})(SignIn);
